import { render, staticRenderFns } from "./SpendVoucher.vue?vue&type=template&id=148baccc&scoped=true&"
import script from "./SpendVoucher.vue?vue&type=script&lang=js&"
export * from "./SpendVoucher.vue?vue&type=script&lang=js&"
import style0 from "./SpendVoucher.vue?vue&type=style&index=0&id=148baccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148baccc",
  null
  
)

export default component.exports